"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    useStandaloneStyles: ()=>useStandaloneStyles,
    StandaloneStyleProvider: ()=>StandaloneStyleProvider
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const defaultStyles = {
    topLevelBoxStyle: {},
    contentFlexStyle: {},
    inputStyle: {},
    recordingIndicatorStyle: {},
    quickActionsContainer: {},
    inputGradientFocus: {},
    inputGradientNoFocus: {}
};
const StyleContext = /*#__PURE__*/ (0, external_react_namespaceObject.createContext)(defaultStyles);
const useStandaloneStyles = ()=>(0, external_react_namespaceObject.useContext)(StyleContext);
const StandaloneStyleProvider = ({ width = '100%', isMobile, children, showLandingChat })=>{
    const inputGradientFocus = {
        backgroundColor: 'transparent',
        border: '2px solid transparent',
        borderRadius: '23px',
        outline: 'none',
        backgroundImage: `
        linear-gradient(144deg, #7701BB 26.24%, #7601BB 30.85%, #7503BC 35.32%, #7205BD 39.67%, #6E09BF 43.9%, #690DC1 48.03%, #6312C4 52.1%, #5C18C7 56.1%, #541FCA 60.07%, #4C27CE 64.01%, #422FD2 67.94%, #3738D7 71.89%, #2C42DC 75.87%),
          radial-gradient(
              37.63% 77.06% at -3.33% 9.11%,
              rgba(245, 235, 250, 0.6) 0%,
              rgba(238, 222, 246, 0.51875) 16.15%,
              rgba(232, 210, 243, 0.441421) 33.33%,
              rgba(209, 168, 232, 0.174338) 66.15%,
              rgba(201, 153, 228, 0.0827664) 82.29%,
              rgba(194, 140, 224, 0) 100%
            )
            /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */,
          radial-gradient(
              22.92% 32.88% at 93.06% 103.5%,
              rgba(232, 242, 255, 0) 0%,
              rgba(232, 242, 255, 0) 0.01%,
              rgba(153, 195, 249, 0) 100%
            )`,
        backgroundClip: 'border-box',
        WebkitBackgroundClip: 'border-box',
        boxShadow: 'inset 0 0 0 1025px #fff'
    };
    const inputGradientNoFocus = {
        border: '2px solid transparent',
        borderRadius: '24px',
        backgroundColor: 'transparent',
        boxShadow: `
        0px -1px 0px 0px rgba(85, 0, 128, 0.03), 0px 1px 4px 0px rgba(85, 0, 128, 0.20), 0px 2px 4px 0px rgba(85, 0, 128, 0.12), 0px 7px 16px 0px rgba(85, 0, 128, 0.16)`
    };
    const topLevelBoxStyle = isMobile ? {
        width,
        height: 'calc(100vh - 200px)',
        maxWidth: '1280px',
        px: 2,
        style: {
            position: 'absolute',
            top: '75px',
            overflowX: 'hidden'
        }
    } : {
        width: '100%',
        maxHeight: 'calc(100vh - 200px)',
        minHeight: 'calc(100vh - 200px)',
        pr: [
            0,
            0,
            0,
            0,
            3,
            3
        ],
        maxWidth: '1280px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        style: {
            overflowY: 'auto',
            overflowX: 'hidden'
        }
    };
    const contentFlexStyle = isMobile ? {
        pb: '56px',
        px: 1,
        width: '100%',
        minHeight: '100%',
        overflowY: 'scroll',
        flexDirection: 'column',
        justifyContent: 'flex-end'
    } : {
        pt: 4,
        pl: [
            0,
            0,
            0,
            0,
            0,
            3
        ],
        width: '100%',
        overflowY: 'scroll',
        maxHeight: 'calc(100% - 200px)',
        flexDirection: 'column',
        justifyContent: 'flex-start'
    };
    const inputStyle = isMobile ? {
        maxWidth: '1280px',
        width,
        position: 'fixed',
        style: isMobile && showLandingChat ? {} : {
            position: 'absolute',
            bottom: 0,
            width: '100%'
        },
        pt: 2
    } : {
        style: {
            maxWidth: '1280px',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%'
        }
    };
    const recordingIndicatorStyle = {
        height: '200px',
        circleHeight: '140px',
        circleWidth: '140px'
    };
    const quickActionsContainer = {
        marginBottom: '12px'
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(StyleContext.Provider, {
        value: {
            topLevelBoxStyle,
            contentFlexStyle,
            inputStyle,
            recordingIndicatorStyle,
            quickActionsContainer,
            inputGradientNoFocus,
            inputGradientFocus
        },
        children: children
    });
};
exports.StandaloneStyleProvider = __webpack_exports__.StandaloneStyleProvider;
exports.useStandaloneStyles = __webpack_exports__.useStandaloneStyles;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "StandaloneStyleProvider",
    "useStandaloneStyles"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
